import Api from '../Api';

import { url } from './config';
import { Location } from './types';

const api = new Api<Location>(url);

export default api;
